import { render, staticRenderFns } from "./BlackListUserListTable.vue?vue&type=template&id=637eb2b6"
import script from "./BlackListUserListTable.vue?vue&type=script&lang=js"
export * from "./BlackListUserListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports